var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_4754_71507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6377 0H5.3623C2.40551 0 0 2.40551 0 5.3623V12.6377C0 15.5945 2.40551 18 5.3623 18H12.6377C15.5945 18 18 15.5945 18 12.6377V5.3623C18 2.40551 15.5945 0 12.6377 0ZM16.1892 12.6377C16.1892 14.5991 14.5991 16.1892 12.6377 16.1892H5.3623C3.40088 16.1892 1.8108 14.5991 1.8108 12.6377V5.3623C1.8108 3.40084 3.40088 1.8108 5.3623 1.8108H12.6377C14.5991 1.8108 16.1892 3.40084 16.1892 5.3623V12.6377Z",
    fill: "url(#paint0_linear_4754_71507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99919 4.34375C6.43218 4.34375 4.34375 6.43218 4.34375 8.99916C4.34375 11.5661 6.43218 13.6546 8.99919 13.6546C11.5662 13.6546 13.6546 11.5662 13.6546 8.99916C13.6546 6.43214 11.5662 4.34375 8.99919 4.34375ZM8.99919 11.8438C7.42813 11.8438 6.15455 10.5703 6.15455 8.99919C6.15455 7.42813 7.42816 6.15455 8.99919 6.15455C10.5703 6.15455 11.8438 7.42813 11.8438 8.99919C11.8438 10.5702 10.5702 11.8438 8.99919 11.8438Z",
    fill: "url(#paint1_linear_4754_71507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6644 5.4967C14.2805 5.4967 14.7799 4.99726 14.7799 4.38116C14.7799 3.76507 14.2805 3.26562 13.6644 3.26562C13.0483 3.26562 12.5488 3.76507 12.5488 4.38116C12.5488 4.99726 13.0483 5.4967 13.6644 5.4967Z",
    fill: "url(#paint2_linear_4754_71507)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4754_71507",
    x1: 9,
    y1: 17.9476,
    x2: 9,
    y2: 0.139809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4754_71507",
    x1: 8.99919,
    y1: 17.9468,
    x2: 8.99919,
    y2: 0.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4754_71507",
    x1: 13.6644,
    y1: 17.9493,
    x2: 13.6644,
    y2: 0.141463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4754_71507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/instaIcon.2b08e83496bdc670a2613d6ee44a8764.svg";
export { ForwardRef as ReactComponent };